import { createContext } from "react";

const pointContext = createContext();

export default pointContext;
